import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";

const MyTeamWorkingInformationTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
}) => {
  const { t } = useTranslation();

  const columns = useMemo(() => {
    return [
      {
        title: <div className="text-table">Employee</div>,
        dataIndex: "employee",
        key: "employee",
        width: 50,
        fixed: "left",
      },
    ];
  }, []);

  const scroll = useMemo(() => {
    return {
      x: 1300,
    };
  }, []);

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      scroll={scroll}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
};

export default MyTeamWorkingInformationTable;
